export default "__VITE_ASSET__BardAAFT__"